import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  AfterViewInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import * as moment from 'moment';
import { ScreenType } from 'src/app/enums/ScreenType';
import {
  INoticeBoardPosts,
  IPostReports,
  PostStatus,
  ReportStatus,
} from 'src/app/models/notice-board';
import * as fromDashboardActions from 'src/app/state-management/actions/dashboard.action';
import { UserRegDetails } from 'src/app/models/user';
import { IUserPolls } from 'src/app/models/user-polls';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
import { PostCardComponent } from './components/post-card/post-card.component';
import { EncryptionService } from 'src/app/services/Encryption/encryption.service';
import { IAumyeState } from 'src/app/state-management/states/aumye.state';
import { Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { IDashboardState } from 'src/app/state-management/states/aumye-dashboard.state';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-user-notice-board',
  templateUrl: './user-notice-board.component.html',
  styleUrls: ['./user-notice-board.component.scss'],
})
export class UserNoticeBoardComponent implements AfterViewInit {
  @Input() set onShareUserPollData(val: IUserPolls) {
    if (val) {
      this.pollData = val;
      this.pollTitle = val.pollTitle;
      this.isPollShared = true;
      const text = `Hi Poll Shared:`;
      this.createPostControl.setValue(text);
    }
  }
  @Input() dataFromStep1: any;
  @Input() parentSelectedPostIndex: number | null;

  @Output() onCreateUserPost = new EventEmitter();
  @Output() onRefreshUserPost = new EventEmitter();
  @Output() onPostComment = new EventEmitter();
  @Output() onPostLike = new EventEmitter();
  @Output() onReportPost = new EventEmitter();

  @Output() onPostShare = new EventEmitter();
  @Output() onOpenSharedPostPollData = new EventEmitter();

  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;
  @ViewChild('picker') picker: MatDatepicker<any>;
  @ViewChild('postTextarea') postTextarea: ElementRef;
  @ViewChild('subChild') subChild: PostCardComponent;

  myForm: FormGroup;

  screenInfo: ScreenType;
  backgroundColor: string = 'transparent';
  loggedIsUsername = '';
  isAdmin = false;
  loggedIsUsernameProfile = '';
  users: UserRegDetails[];
  isPollShared = false;
  pollTitle = '';
  posts: INoticeBoardPosts[];
  polls: IUserPolls[];
  userImage =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAMAAAD04JH5AAAAMFBMVEXk5ueutLepr7Ln6erg4uPJzc/T1ti7wMO2u77DyMqzuLvq7O3P0tTW2dvc3+DZ3N7ueM45AAAC2UlEQVR4nO2a2ZLjIAxFAYHZvPz/3za2O8v0JCA5kl3dxXly5eXeCAmDZKU6nU6n0+l0Op1O5/cCAErZglofzle3UwxJryTvFnWuB4DJa2P0DWNSnM+zAHnUD/G7Cb/kc/Tz9EJ+t3DKQkB8Lb8xiDsAFSr62jhhB2BTRX51EEUdgK3Lb4kg6qDx/6VjAL6tXxyMUg7A1fLvyYHQngQLTr/szUIGAlJfqBhhxAagIKCvAC+vtUQIBkIAtOE3kNEZsBkQKEVKALQO3AZIKbiGwHIbQG2CTwbYX8w0fa253wgzbQVKEvDqA6kIN5gNIN9DT8y8BiJVXy8XGzATrwFiFa51+McMXL4Elyfh1WVIOw1s8OorS96K/9rL6PLXMfVAorkPJApoBvivqLQ1MBP/oRR9MdsQuBcA4mp+D4DI3WwihEDkdorPAv4j8U67P/ONVJcGvRdYqRZJ9hgHEiV4A9OjkGsRbVTblJu+dKuy4UBcvxRjtVUr3ywup7P38uGUoQHM74Lgzprd5OVFJpgoVv6vLMzu35FNGE+eGq1TqzH6kFIKPg7XDM4y3Mhnz8zK/7XLMLq44cZhmfdfTxDPah5jKKu+ck+B9TlFNynRYKzDSheek+9nIWiT4mBlIlGCPnj9ZmD3bMLo4Gb2kthHpS3xhwk/sFoA5RLxXmLKvsQ1SAVbG1VWPISFIwpF/oj6bsEzWHg1pyZYiJ/lQl6oa/+fAz1+kAr52OL/sJCOBgHm5gEQybFjEgw86nrLBDqZ3herOPDkRKh+pnDAAXV8wKyvqQMMfn2aA9b1fzhA5wFQWhF48N9WkLuiWAfY/YA0pCWBamAfaIyjQTWQ0Y2YA2B6B5k8nCHRDgB5REqi3T6gT6eINNdANADtUpQsgR3fCIDcHnCjPkiQ2gQf1NfgwJSeTPVscmA+SSbVVgD/tdYHVJOAMJQ4TG2ma78bD6LwjtU7nU6n8/v5AuY6HZyRatEhAAAAAElFTkSuQmCC';

  commentControl = new FormControl();
  createPostControl = new FormControl();
  uploadedAttachmentControl = new FormControl();
  uploadedAttachment = '';
  isFileSelected: boolean;
  filteredUserList: string[] = [];
  filteredUserOrgList: UserRegDetails[] = [];
  showUserList = false;
  showMentionList = false;
  selectedMention: string | null = null;
  selectedIndex: number = -1;
  showRemoveButton: boolean = false;
  selectedDate: Date;
  maxDate: Date;
  minDate: Date;
  pollData: IUserPolls;
  currentUserId: string = null;
  destroyed$: Subject<any> = new Subject<any>();
  dashboardState$: Observable<IDashboardState>;
  dashboardData: IDashboardState;
  postIdFromRoute: string | null = null;

  constructor(
    private _screen: AumyeResponsiveScreenService,
    private encryption: EncryptionService,
    private store: Store<IAumyeState>,
    private route: ActivatedRoute
  ) {
    this._screen.getScreenType().subscribe((screenData) => {
      this.screenInfo = screenData;
    });
    this.dashboardState$ = this.store.select('aumyeDashboardState');
    this.dashboardState$.pipe(takeUntil(this.destroyed$)).subscribe((data) => {
      this.dashboardData = data;
      this.setUserListdata(this.dashboardData.orgUserList);
      this.setUserPostsdata(this.dashboardData.noticeBoardPosts);
      this.polls = this.dashboardData.userPolls;
    });
    this.currentUserId = this.encryption.getCurrentUser().userID;
    this.loggedIsUsername = this.encryption.getCurrentUser().fullName;
    this.isAdmin = this.encryption.getCurrentUser().role == 'admin';
    this.loggedIsUsernameProfile = localStorage.getItem('ProfilePic')
      ? localStorage.getItem('ProfilePic')
      : this.userImage;
    this.maxDate = new Date();
    this.minDate = new Date();
    this.maxDate.setDate(this.maxDate.getDate() + 7);
  }
  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      this.postIdFromRoute = params.get('postId');
    });

    if (this.currentUserId == null) {
      this.currentUserId = this.encryption.getCurrentUser().userID;
    }
  }
  ngAfterViewInit() {
    this.scrollToHighlightedPost();
  }

  private scrollToHighlightedPost() {
    if (!this.postIdFromRoute) return;

    // Defer slightly so the DOM is painted
    setTimeout(() => {
      const el = document.getElementById(`post-${this.postIdFromRoute}`);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 0);
  }
  isPollTitleEditable: boolean = false;
  setUserListdata(users: UserRegDetails[]) {
    this.users = users;
  }
  setUserPostsdata(posts: INoticeBoardPosts[]) {
    if (!this.isAdmin) {
      this.posts = posts.filter((x) => !x.isPending && !x.flaggedPost);
    } else {
      this.posts = posts;
    }
  }
  onCommentInput() {}
  handleFileChange(event: any) {
    const selectedFile = event.target.files[0];

    if (selectedFile && this.isImageFile(selectedFile)) {
      // Handle the selected image file
      if (event.target.files[0]) {
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event: any) => {
          this.uploadedAttachment = event.target.result;
        };
      }
    } else {
    }
  }

  isImageFile(file: File): boolean {
    return file.type.startsWith('image/');
  }
  selectFile() {
    this.isFileSelected = false;
    this.fileInput.nativeElement.click();
  }

  onCommentInputCheck(event: Event) {
    const inputText = this.createPostControl.value;
    const atIndex = inputText.lastIndexOf('@');
    if (atIndex !== -1) {
      const searchTerm = inputText.substring(atIndex + 1);
      this.filteredUserOrgList = this.users.filter(
        (user) =>
          user.firstname.toLowerCase().includes(searchTerm.toLowerCase()) ||
          user.lastname.toLowerCase().includes(searchTerm.toLowerCase())
      );
      this.showUserList = this.filteredUserOrgList.length > 0;
    } else {
      this.showUserList = false;
    }
  }

  selectUser(user: UserRegDetails) {
    this.selectedMention = user.firstname;
    const inputText = this.createPostControl.value;
    const atIndex = inputText.lastIndexOf('@');
    const newText = `${inputText.substring(0, atIndex + 1)}${
      this.selectedMention
    }`;
    this.createPostControl.setValue(newText);
    this.showUserList = false;
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      if (this.selectedIndex < this.filteredUserList.length - 1) {
        this.selectedIndex++;
      }
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      if (this.selectedIndex > 0) {
        this.selectedIndex--;
      }
    } else if (event.key === 'Enter') {
      event.preventDefault();
      if (this.selectedIndex !== -1) {
        const selectedUser = this.filteredUserList[this.selectedIndex];
        // this.selectUser(selectedUser);
      }
      if (!!this.commentControl.value) {
        this.onCommentInput();
      }
    }
  }
  removeImage() {
    this.uploadedAttachment = ''; // Clear the uploadedAttachment to remove the image
  }

  createPost() {
    if (!this.selectedDate) {
      this.selectedDate = new Date();
      const numberOfDaysToAdd = 5;
      this.selectedDate.setDate(
        this.selectedDate.getDate() + numberOfDaysToAdd
      );
    }
    const userPost = {
      attachment: this.uploadedAttachment,
      description: this.createPostControl.value,
      username: this.loggedIsUsername,
      sharedPoll: this.isPollShared,
      postSharedId: this.pollData?.pollId,
      validDate: this.selectedDate.toISOString(),
      userProfile: localStorage.getItem('ProfilePic')
        ? localStorage.getItem('ProfilePic')
        : this.userImage,
    };
    this.store.dispatch(
      new fromDashboardActions.CreateNoticeBoardPost(userPost)
    );
    this.createPostControl.setValue('');
    this.uploadedAttachment = null;
    this.selectedDate = null;
    this.isPollShared = false;
  }
  refreshNoticeBoard() {
    this.store.dispatch(new fromDashboardActions.GetNoticeBoardPosts({}));
  }
  getFormatedDateTime(val: Date) {
    let formatedDate = moment(val, 'YYYY-MM-DDTHH:mm:ss.SS').fromNow();
    return formatedDate;
  }
  openDatePicker() {
    this.picker.open();
  }
  onPostUserComment(val: any) {
    val = {
      ...val,
      isIncident: false,
      isVisitor: false,
      userProfile: localStorage.getItem('ProfilePic')
        ? localStorage.getItem('ProfilePic')
        : this.userImage,
      username: this.loggedIsUsername,
    };
    this.store.dispatch(new fromDashboardActions.PostUserComment(val));
  }
  onPostLikeComment(val: any) {
    val = {
      ...val,
      username: this.loggedIsUsername,
    };
    this.store.dispatch(new fromDashboardActions.PostUserLike(val));
  }
  onReportPostFn(val: any) {
    this.store.dispatch(new fromDashboardActions.ReportCommunityPost(val));
  }
  onPostUserShare(val: any) {
    this.createPostControl.setValue(val.postDescription);
    this.uploadedAttachment = val.postAttachment;
    // this.onPostShare.emit(val);
  }
  onOpenSharedPostPoll(val: any) {
    this.onOpenSharedPostPollData.emit(val);
  }
  isPostReportsOpened = false;
  showDashboard: boolean = false;

  toggleDashboard(): void {
    this.showDashboard = !this.showDashboard;
  }
  onPostReportsOpened(opened: boolean) {
    this.isPostReportsOpened = opened;
  }
  focusTextarea() {
    this.postTextarea.nativeElement.focus();
  }
  getPostPoll(post: INoticeBoardPosts): IUserPolls {
    const foundPoll = this.polls.find(
      (poll) => poll.pollId === post.postSharedId
    );
    return foundPoll;
  }

  onPostActionTaken(val: { post: INoticeBoardPosts; action: PostStatus }) {
    const data = {
      postId: val.post.postId,
      reviewNotes: null as string | null, // or just null if your type allows
      action: val.action,
    };

    this.store.dispatch(new fromDashboardActions.AcceptOrRejectPost(data));
  }
  onPostFlaggedpostAction(val: {
    post: INoticeBoardPosts;
    action: ReportStatus;
  }) {
    const data = {
      postId: val.post.postId,
      reviewNotes: null as string | null, // or just null if your type allows
      action: val.action,
    };
    this.store.dispatch(new fromDashboardActions.UpdateFlaggedPost(data));
  }

  getDeviceType(screen: ScreenType): 'mobile' | 'tablet' | 'desktop' {
    switch (screen) {
      case ScreenType.Mobile:
        return 'mobile';
      case ScreenType.Tablet:
        return 'tablet';
      case ScreenType.Desktop:
      default:
        return 'desktop';
    }
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const targetElement = event.target as HTMLElement;
    const userlistElement = document.querySelector('.user-list');

    if (userlistElement && !userlistElement.contains(targetElement)) {
      this.showUserList = false;
    }
  }

  @HostListener('document:keydown.escape')
  onDocumentEscape() {
    this.showUserList = false;
  }
  ScreenType = ScreenType;
}
